module.exports = __webpack_public_path__ + "static/media/naytteiden-ottoa-tynnyreista.7af923a5.mp4";


/*****************
 ** WEBPACK FOOTER
 ** ./media/videos/naytteiden-ottoa-tynnyreista.mp4
 ** module id = 462
 ** module chunks = 0
 **/